export class Messages {}

Messages.DeleteQuestion = "Are you sure you want to delete the record?";
Messages.OperationSuccess = "Operation Succeeded";
Messages.OperationError = "An Error has occurred";
Messages.LogoutQuestion = "Are you sure that you want to logout?";
